import { useSearchParams } from 'react-router-dom';
import { Worksheet, WorksheetBase } from '../../../types/worksheet';
import QueriesContainer from './client-queries/QueriesContainer';
import { QueriesAddonProvider } from './client-queries/useQueriesAddon';
import CommentsContainer from './internal-comments/CommentsContainer';
import { CommentsAddonProvider } from './internal-comments/useCommentsAddon';
import SidePanel from '../../../components/side-panel/SidePanel';
import ReviewConditionsContainer from './review-conditions/ReviewConditionsContainer';

type AddonsSidebarProps = {
    worksheet: Worksheet;
};

function AddonsSidebar({ worksheet }: AddonsSidebarProps): JSX.Element | null {
    const [search, setSearch] = useSearchParams();
    const addon = search.get('addon');

    function handleClose(): void {
        setSearch(
            (s) => {
                s.delete('addon');
                return s;
            },
            { replace: true }
        );
    }

    return (
        <SidePanel onClose={handleClose} isOpen={addon !== null}>
            {addon === 'internalComments' && (
                <CommentsAddonProvider>
                    <CommentsContainer worksheet={worksheet} key={worksheet.id} />
                </CommentsAddonProvider>
            )}
            {addon === 'clientQueries' && (
                <QueriesAddonProvider>
                    <QueriesContainer worksheet={worksheet} key={worksheet.id} />
                </QueriesAddonProvider>
            )}
            {addon === 'reviewConditions' && <ReviewConditionsContainer worksheet={worksheet} key={worksheet.id} />}
        </SidePanel>
    );
}

export default AddonsSidebar;
